import {
    Button, VStack, Text, HStack, List, ListItem,
    ListIcon, IconButton, Drawer, DrawerOverlay, DrawerContent,
    DrawerHeader, DrawerBody, useDisclosure, Link, Collapse
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { MdAdd, MdAdminPanelSettings, MdChat, MdHistory, MdMenu } from 'react-icons/md';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import fetchWrapper from '../lib/fetch-wrapper';
import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useProfile } from '../lib/profileContext';
import { useTranslation } from 'react-i18next';
import { url } from '../lib/constants';

const SideBarMobile = ({ onActivityClick, onClearChat, isAdmin, isPowerBIViewer }:
                       { onActivityClick: (sessionId: string) => void, onClearChat: () => void, isAdmin: boolean, isPowerBIViewer: boolean }) => {

    const { t } = useTranslation();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [sessions, setSessions] = useState<any[]>([]);
    const [show, setShow] = useState(false);
    const { instance, accounts }: { instance: IPublicClientApplication, accounts: AccountInfo[] } = useMsal();
    const { profile } = useProfile();

    const handleToggle = () => {
        setShow(!show);
    };

    const goToAdminDashboard = () => {
        window.open('/#/admin', '_blank');
        onClose();
    };

    useEffect(() => {
        if (isOpen) {
            const fw = new fetchWrapper();
            fw.get(`${url}/api/recent`)
                .then((res) => {
                    if (res.status === 200) {
                        setSessions(res.data);
                    }
                })
                .catch((ex: any) => console.log(ex));
        }
    }, [isOpen]);

    return (
        <>
            <IconButton
                icon={<MdMenu size="2.5em" color="#a32b29" />}
                size="md"
                position="absolute"
                top={3}
                left={3}
                zIndex={100}
                onClick={onOpen}
                aria-label="Open Menu"
            />

            <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
                <DrawerOverlay />
                <DrawerContent bg="white" height={'100dvh'}>

                    <DrawerHeader display="flex" justifyContent="space-between" bg={'brand.900'}>
                        <IconButton icon={<MdMenu color="#a32b29" />} onClick={onClose} aria-label="Close Menu" />
                    </DrawerHeader>

                    <DrawerBody color={'brand.500'} bg={'brand.900'}>
                        <VStack align="flex-start" spacing={4}>

                            <Button leftIcon={<MdAdd />} bg="brand.500" color="brand.900" onClick={() => { onClearChat(); onClose(); }}>
                                {t('new_chat')}
                            </Button>
                            {isAdmin && (
                                <HStack cursor="pointer" onClick={goToAdminDashboard}>
                                    <MdAdminPanelSettings size="1.5em" />
                                    <Text fontWeight="600">{t('admin_board')}</Text>
                                </HStack>
                            )}

                            <HStack>
                                <MdHistory size="1.5em" />
                                <Text fontWeight="600">{t('recent_activity')}</Text>
                            </HStack>

                            <Collapse startingHeight={sessions.length > 5 ? 200 : 100} in={show}>
                                <List mt={3} maxH={show ? 'calc(100vh - 350px)' : 200} overflowY="auto">
                                    {sessions.map((session) => (
                                        <ListItem
                                            key={session.SessionId}
                                            padding={2}
                                            cursor="pointer"
                                            _hover={{ backgroundColor: "brand.500", color: 'brand.900', borderRadius: 5 }}
                                            onClick={() => { onActivityClick(session.SessionId); onClose(); }}
                                        >
                                            <ListIcon as={MdChat} />
                                            {session.Question}
                                        </ListItem>
                                    ))}
                                </List>
                            </Collapse>

                            {sessions.length > 5 && (
                                <Text fontWeight="600" cursor="pointer" size="sm" onClick={handleToggle} mt="1rem" ml={3}>
                                    {show ? t('show_less') : t('show_more')}
                                </Text>
                            )}

                            {(isAdmin || isPowerBIViewer) && (
                                <Link href={import.meta.env.VITE_REPORTS_ENDPOINT} target="_blank">
                                    <HStack>
                                        <HiOutlineDocumentReport size="1.5em" />
                                        <Text fontWeight="600">{t('reports')}</Text>
                                    </HStack>
                                </Link>
                            )}
                        </VStack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
};

export default SideBarMobile;
